import React, { useEffect, useState } from "react";
import {
  Box,
  CircularProgress,
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
  Stack,
  Typography,
} from "@mui/material";
import { Close } from "@mui/icons-material";
import { usePreviewTemplateQuery } from "./templatesApiSlice";

function TemplatePreviewModal({ open, onClose, template }) {
  const [blobUrl, setBlobUrl] = useState(null);

  const { data: htmlContent, isFetching, isError } = usePreviewTemplateQuery(
    template?.id,
    { skip: !open || !template?.id }
  );

  useEffect(() => {
    if (!htmlContent) {
      setBlobUrl(null);
      return;
    }
    const blob = new Blob([htmlContent], { type: "text/html" });
    const url = URL.createObjectURL(blob);
    setBlobUrl(url);
    return () => URL.revokeObjectURL(url);
  }, [htmlContent]);

  const handleClose = () => {
    setBlobUrl(null);
    onClose();
  };

  return (
    <Dialog open={open} onClose={handleClose} maxWidth="lg" fullWidth>
      <DialogTitle>
        <Stack direction="row" alignItems="center" justifyContent="space-between">
          <Typography variant="h6">
            Preview — {template?.name}
          </Typography>
          <IconButton onClick={handleClose} size="small">
            <Close />
          </IconButton>
        </Stack>
      </DialogTitle>
      <DialogContent dividers sx={{ p: 0, height: "75vh" }}>
        {isFetching ? (
          <Box
            display="flex"
            alignItems="center"
            justifyContent="center"
            height="100%"
          >
            <CircularProgress />
          </Box>
        ) : isError ? (
          <Box
            display="flex"
            alignItems="center"
            justifyContent="center"
            height="100%"
          >
            <Typography color="error">Failed to load template preview.</Typography>
          </Box>
        ) : blobUrl ? (
          <iframe
            src={blobUrl}
            title="Template Preview"
            style={{ width: "100%", height: "100%", border: "none" }}
            sandbox="allow-same-origin"
          />
        ) : null}
      </DialogContent>
    </Dialog>
  );
}

export default TemplatePreviewModal;
